import { Guid } from 'guid-typescript';
import { Endorsement } from '../../models/form-state.model';

export interface EndorsementState {
  endorsements: Endorsement[];
}

export const initialState: EndorsementState = {
  endorsements: [
    {
      NumeroContrat: Guid.create(),
      RefContrat: '',
      ClientAdvisorFullName: '',
      productName: '',
      correlationId: Guid.create(),
      isChecked: false
    }
  ]
};
